<template>
  <div class="paymentSuccess">
    <header-view :tabsign='1'></header-view>
    <div class="body w12 min-h">
      <div class="box-out">
        <div class="f-row-c">
          <el-image class="box" fit="contain" :src='require("./../../assets/bgimg.png")'></el-image>
        </div>
        <div class="cont">
          <div class="tit">
            {{query.type!=1?'提交成功，请联系平台工作人员获取捐赠证书！':'支付成功'}}
          </div>
          <div class="f-row-c btnbox">
            <div class="btn btn-red" v-if='query.type==1' @click="downloadbtn">{{isIos?'查看证书':'下载证书'}}</div>
            <div class="btn" @click="goHome">返回首页</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "paymentSuccess",

  data: function() {
    return {
      isIos:false,
      query: "",
      info:{},
    };
  },
  created() {
    this.query = this.$route.query;
    this.setQuery()
  },
  mounted() {
    this.isIosFn();
  },
  methods: {
    getUrlArg(urls,portId){//获取扫描得到的url上的参数
		  var that=this;
      var arr=urls?urls.split('&'):[];
      var dataVal={}
      arr.forEach(k=>{
        if(k){
          dataVal[k.split('=')[0]]=k.split('=')[1]
        }
      })
      console.log('dataVal',dataVal)
      return dataVal[portId]||'';
    },
    setQuery(){
      var url=window.location.href;
      var str=this.query?JSON.stringify(this.query):this.query;
      console.log('query',this.query,url)
      if(url.indexOf('out_trade_no')!=-1){  
        this.$set(this.query,'type',1);
        this.$set(this.query,'id',this.getUrlArg(url?url.split('?')[1]:'','out_trade_no'));
        console.log('query111',this.query,);
        window.location.href=`${url.split('?')[0]}?type=${this.query.type}&id=${this.query.id}`;
        // location.reload();
      }
    },
    isIosFn(){
      let u = navigator.userAgent
      // let isAndroid = u.index0f('Android')>-1||u.index0f('Adr')>-1 // android终端
      this.isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)//!!u.match(matcher:/\(i[^;]+;(U;)?CPU.+Mac OS X/) //ios终端
    },
    goHome() {
       this.$router.push({ path: "/"});
    },
    downloadbtn(){
      // window.location.href = this.imageUrl + this.info.certificateUrl;
       this.httpGet("web/unionPay/downloadDonate", {
          recordId: this.query.id
        }).then(res=>{ 
          if(res.success){ 
            if(this.isIos){ 
              window.location.href=this.getFileAccessHttpUrl(res.result)
            }else{  
              window.open(this.getFileAccessHttpUrl(res.result))
            }
           
          }else{ 
            this.$message.success(res.message)
          }
          
        })
    }
  }
};
</script>
<style scoped lang="scss">
.paymentSuccess {
  width: 100%;
  position: relative;
  .body {
    background: #ffffff;
    margin: 120px auto 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    .box-out{
      min-height: 200px;
      .btnbox,.btn,.btn-red,.f-row-c{
        display: flex;
        justify-content: center;
        align-items: center;
        cursor:pointer;
      }
      .box{ 
        width:156px;
        height:142px;
        margin: auto;
      }
      .cont{
        margin-top: 10px;
        text-align: center;
        font-weight: 400;
        .tit{
          color: #E61F26;
          font-size: 18px;
          margin-bottom: 49px;
        }
        
        .btn,.btn-red{
          margin: 0px 10px;
          width: 168px;
          height: 36px;
          background: #E6E6E6;
          color: #333333;
          font-size: 16px;
        }
        .btn-red{
          background: #E61E26;
          color: #ffffff;
        }
      }
    }
    

  }
}
</style>
